// extracted by mini-css-extract-plugin
module.exports = {"profileRecruitmentContainer":"zfmZnAQl","question":"wu6CfHfq","answer":"_2HJzf8ou","marginBottom":"_2He1hYEa"};
    if(module.hot) {
      // 1754514963240
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  